module.exports = __webpack_public_path__ + "static/Live-Chat-91a651576557b8a01dbee5bd7ad490b7.png";